import React from 'react';
import classNames from 'classnames/bind';
import Button from 'js/components/button/button';
import styles from '../quick-start.module.scss';

const cx = classNames.bind(styles);

const IntegrationButton = ({ label, logo, active, disabled, onClick }) => (
    <Button
        theme="select"
        size="auto"
        active={active}
        disabled={disabled}
        onClick={onClick}
    >
        <div
            className={cx({
                'integration-button': true,
                'has-logo': !!logo,
                active,
            })}
        >
            {logo && <img className={styles.logo} src={logo} alt="" />}
            <div className={styles.label}>{label}</div>
        </div>
    </Button>
);

export default IntegrationButton;
